"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.filterKeyPress = exports.keyCodeMap = exports.getBloomreachUrlBasedOnBrand = exports.bloomreachUrlMapping = exports.isMobileDevice = exports.default = void 0;

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var getLinkTrackingAttr = function getLinkTrackingAttr(dataLinkId) {
  var dataLinkPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
  var dataLinkModule = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'global-header';
  var dataLinkModuleType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'search-component';
  var dataLinkModulePosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'none';
  return {
    'data-link-id': dataLinkId,
    'data-link-module': dataLinkModule,
    'data-link-module-type': dataLinkModuleType,
    'data-link-module-position': dataLinkModulePosition,
    'data-link-position': dataLinkPosition
  };
};

var _default = getLinkTrackingAttr;
/**
 * isMobileDevice
 * returns boolean if its mobile device or not
 */

exports.default = _default;

var isMobileDevice = function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(typeof window !== 'undefined' ? window.navigator.userAgent : '');
};
/**
 * return bloomreach api
 * @return {string}
 */


exports.isMobileDevice = isMobileDevice;
var bloomreachUrlMapping = {
  shutterfly: {
    dev: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=6302&domain_key=shutterfly_qa&request_id=5761379060594&request_type=suggest&view_id=DESKTOP',
    beta: 'https://suggest.dxpapi.com/api/v1/suggest/?account_id=6302&domain_key=shutterfly_qa&request_id=8992231613941&request_type=suggest&view_id=DESKTOP',
    stage: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=5086&domain_key=shutterfly&request_id=6624595919448&request_type=suggest&view_id=DESKTOP',
    kappa: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=5086&domain_key=shutterfly&request_id=6624595919448&request_type=suggest&view_id=DESKTOP',
    production: 'https://suggest.dxpapi.com/api/v1/suggest/?account_id=5086&domain_key=shutterfly&request_id=6624595919448&request_type=suggest&view_id=DESKTOP',
    dev1: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=6302&domain_key=shutterfly_qa&request_id=5761379060594&request_type=suggest&view_id=DESKTOP',
    beta1: 'https://suggest.dxpapi.com/api/v1/suggest/?account_id=6302&domain_key=shutterfly_qa&request_id=8992231613941&request_type=suggest&view_id=DESKTOP',
    kappa1: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=5086&domain_key=shutterfly&request_id=6624595919448&request_type=suggest&view_id=DESKTOP',
    stage1: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=5086&domain_key=shutterfly&request_id=6624595919448&request_type=suggest&view_id=DESKTOP',
    prod1: 'https://suggest.dxpapi.com/api/v1/suggest/?account_id=5086&domain_key=shutterfly&request_id=6624595919448&request_type=suggest&view_id=DESKTOP'
  },
  tinyprints: {
    dev: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=6303&domain_key=tinyprints_qa&request_id=8022796829568&request_type=suggest&view_id=DESKTOP',
    beta: 'https://suggest.dxpapi.com/api/v1/suggest/?account_id=6303&domain_key=tinyprints_qa&request_id=9970993292908&request_type=suggest&view_id=DESKTOP',
    stage: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=5019&domain_key=tinyprints&request_id=8784942876365&request_type=suggest&view_id=DESKTOP',
    kappa: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=5019&domain_key=tinyprints&request_id=8784942876365&request_type=suggest&view_id=DESKTOP',
    production: 'https://suggest.dxpapi.com/api/v1/suggest/?account_id=5019&domain_key=tinyprints&request_id=8784942876365&request_type=suggest&view_id=DESKTOP',
    dev1: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=6303&domain_key=tinyprints_qa&request_id=8022796829568&request_type=suggest&view_id=DESKTOP',
    beta1: 'https://suggest.dxpapi.com/api/v1/suggest/?account_id=6303&domain_key=tinyprints_qa&request_id=9970993292908&request_type=suggest&view_id=DESKTOP',
    kappa1: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=5019&domain_key=tinyprints&request_id=8784942876365&request_type=suggest&view_id=DESKTOP',
    stage1: 'https://staging-suggest.dxpapi.com/api/v1/suggest/?account_id=5019&domain_key=tinyprints&request_id=8784942876365&request_type=suggest&view_id=DESKTOP',
    prod1: 'https://suggest.dxpapi.com/api/v1/suggest/?account_id=5019&domain_key=tinyprints&request_id=8784942876365&request_type=suggest&view_id=DESKTOP'
  }
};
/**
 * gets bloomreach API  based on brand and env fron bloomreachUrlMapping
 * @param {string} brand
 * @param {string} env
 * @return {string}
 */

exports.bloomreachUrlMapping = bloomreachUrlMapping;

var getBloomreachUrlBasedOnBrand = function getBloomreachUrlBasedOnBrand(brand, env) {
  return bloomreachUrlMapping[brand][env];
};

exports.getBloomreachUrlBasedOnBrand = getBloomreachUrlBasedOnBrand;
var keyCodeMap = {
  enter: 13,
  escape: 27,
  space: 32,
  arrowLeft: 37,
  arrowUp: 38,
  arrowRight: 39,
  arrowDown: 40,
  tab: 9
};
exports.keyCodeMap = keyCodeMap;

var filterKeyPress = function filterKeyPress(event) {
  var keyCodesMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return keyCodesMap.includes(event.which) || keyCodesMap.includes(event.keyCode) || keyCodesMap.includes(event.charCode);
};

exports.filterKeyPress = filterKeyPress;